import { z } from 'zod/v4';
import { PerformedBySchema } from '../performed-by/index.js';
export const CosmoUserNoteSchema = z.object({
    id: z.uuid(),
    text: z.string(),
    createdAt: z.iso.datetime({ offset: true }),
    createdBy: PerformedBySchema.nullable(),
    updatedAt: z.iso.datetime({ offset: true }).optional(),
    updatedBy: PerformedBySchema.nullable().optional(),
});
export const CreateCosmoUserNoteInputSchema = z.object({
    text: z.string().min(1),
});
export const UpdateCosmoUserNoteInputSchema = z.object({
    text: z.string().min(1),
});
//# sourceMappingURL=notes.js.map